import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ButtonGroup } from "primeng/buttongroup";

@Component({
    selector: "kno2-button-group",
    imports: [ButtonGroup],
    template: `
        <p-buttongroup>
            <ng-content />
        </p-buttongroup>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonGroupComponent {}
